import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { UserActivityAxios, OnboardingAxios } from "../../API";

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import authSlice from '../../store/auth/authSlice';

export default function CoachStats() {
    const dispatch = useDispatch();
    const updateCoachStats = useSelector((state) => state.auth.updateCoachStats);
    const loggedInUser = useSelector((state) => state.auth.loggedInUser);
    const allActivities = useSelector((state) => state.auth.missionDetails.tasks);

    const [result, setResult] = useState(null);

    useEffect(() => {
        OnboardingAxios.get('OfferingUsers/getmyteamconnections/' + loggedInUser.offeringUserId)
            .then(function (response) {
                let teamMembers = [];
                if (response.data.length > 0) {
                    teamMembers = response.data;
                    var teamMemberIds = teamMembers.map(function (e) { return e.offeringUserId; }).join(',');
                    var indivisualIds = allActivities.filter(x => x.activityTypeId === 3).map(function (e) { return e.activityId; }).join(',');
                    var meetingIds = allActivities.filter(x => x.activityTypeId === 1).map(function (e) { return e.activityId; }).join(',');

                    UserActivityAxios.get(`OfferingUserActivity/getcoachstats/${indivisualIds}/${meetingIds}/${teamMemberIds}`)
                        .then(function (res) {
                            setResult(res.data);
                            dispatch(authSlice.actions.setCoachStatsData(res.data));
                        })
                        .catch(function (er) {
                            console.log(er);
                        });
                }
            });
    }, [updateCoachStats]);

    return (
        result && <div className="coach-stats-wrapper">
            <Row className="coach-stats-row">
                <Col sm={8} >
                    <span>Submission pending review</span>
                </Col>
                <Col sm={4} >
                    <span>{result.totalSubmissions - result.completedSubmissions}</span>
                </Col>
            </Row>
            <Row className="coach-stats-row">
                <Col sm={8} >
                    <span>Submission completed</span>
                </Col>
                <Col sm={4} >
                    <span>{result.completedSubmissions}</span>
                </Col>
            </Row>
            <Row className="coach-stats-row">
                <Col sm={8} >
                    <span>Feedback given</span>
                </Col>
                <Col sm={4} >
                    <span>{result.feebackGiven}</span>
                </Col>
            </Row>
        </div>
    );
}
